var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxShoppingBag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3543 19.629C20.3766 19.8275 20.3565 20.0285 20.2955 20.2189C20.2345 20.4092 20.134 20.5844 20.0004 20.733C19.8665 20.8814 19.7026 20.9999 19.5197 21.0803C19.3367 21.1608 19.1386 21.2017 18.9388 21.2002H5.12355C4.92364 21.2017 4.72568 21.1608 4.5427 21.0803C4.35972 20.9999 4.19586 20.8814 4.06193 20.733C3.92835 20.5844 3.82776 20.4092 3.76677 20.2189C3.70577 20.0285 3.68576 19.8275 3.70805 19.629L4.95369 8.46069H19.1086L20.3543 19.629Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49219 8.46203V6.33879C8.49219 5.40026 8.86502 4.50016 9.52866 3.83652C10.1923 3.17288 11.0924 2.80005 12.0309 2.80005C12.9695 2.80005 13.8696 3.17288 14.5332 3.83652C15.1968 4.50016 15.5697 5.40026 15.5697 6.33879V8.46203",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxShoppingBag);
export default __webpack_public_path__ + "static/media/icon_24px_shopping-bag.36d6cffae48793fb370148970bd4c936.svg";
export { ForwardRef as ReactComponent };